import { NextApiResponse } from "next";
import { IndexedObject } from "types/general.types";
import { serialize, CookieSerializeOptions } from "cookie";

export const parseCookies = (cookie: string): IndexedObject => {
  const cookiesArr = cookie.split(";");
  return cookiesArr.reduce((results, item) => {
    const [key, value] = item.trim().split("=");
    return {
      ...results,
      [key]: decodeURIComponent(value),
    };
  }, {});
};

export const getTokenFromCookies = (cookies: string) => {
  if (!cookies) {
    return null;
  }
  let parsedCookies = parseCookies(cookies);
  if (!Object.keys(parsedCookies).includes("@@dive")) {
    return null;
  }
  return parsedCookies["@@dive"];
};

export const setCookie = (
  res: NextApiResponse,
  name: string,
  value: unknown,
  options: CookieSerializeOptions = {}
) => {
  const stringValue =
    typeof value === "object" ? "j:" + JSON.stringify(value) : String(value);

  if ("maxAge" in options) {
    options.expires = new Date(Date.now() + options.maxAge);
    options.maxAge /= 1000;
  }

  res.setHeader("Set-Cookie", serialize(name, stringValue, options));
};
